
import { defineComponent } from 'vue';
import { AppFormRow, AppInput, AppCard, AppButton } from '@/components';
import { useAvatarColorAdd } from '@/modules/avatar/color/model/add';
import { ROUTE_NAME_AVATAR } from '@/modules/avatar/router';

export default defineComponent({
    name: ROUTE_NAME_AVATAR.COLOR.ADD,
    components: { AppFormRow, AppInput, AppCard, AppButton },
    setup() {
        const { model, v$, create } = useAvatarColorAdd();

        return { v$, model, create };
    }
});
